import type { ReactNode } from "react"
import { Box, Stack, Typography } from "@mui/material"
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'

interface PosPagamentoLayoutProps {
    valorFormatado: string
    /** O totem de pedidos reusa esta tela para perguntar da nota, onde não houve "pagamento aprovado". */
    titulo?: string
    /** Dentro do passo do pagamento do checkout, em vez de cobrir a tela inteira. */
    embutido?: boolean
    children: ReactNode
}

/** O certo verde com o título: o mesmo no pós-pagamento do checkout e na tela da senha do totem de pedidos. */
export function CabecalhoSucesso({ titulo }: { titulo: string }): JSX.Element {
    return (
        <Stack spacing={1} sx={{ alignItems: 'center', textAlign: 'center' }}>
            <CheckCircleRoundedIcon sx={{ fontSize: 88, color: 'success.main' }} />

            <Typography variant="h3" sx={{ fontWeight: 'bold', color: 'success.main' }}>
                {titulo}
            </Typography>
        </Stack>
    )
}

export default function PosPagamentoLayout({ valorFormatado, titulo = 'Pagamento Aprovado!', embutido = false, children }: PosPagamentoLayoutProps): JSX.Element {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                p: 3,
                ...(embutido
                    ? { width: '100%', flex: '1 0 auto' }
                    : { inset: 0, position: 'fixed', zIndex: (theme) => theme.zIndex.modal, backgroundColor: 'background.default' }),
            }}
        >
            <CabecalhoSucesso titulo={titulo} />

            <Box sx={{ mt: 2, width: '100%', maxWidth: 720, display: 'flex', justifyContent: 'center' }}>
                {children}
            </Box>
        </Box>
    )
}
